import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-SLT',
  templateUrl: './SLT.component.html',
  styleUrls: ['./SLT.component.scss'],
})
export class SLT implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
